import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductCard from '@/components/cards/ProductCard/index.vue';
import NewsCard from '@/components/cards/NewsCard/index.vue';
import InstaBlock from '@/components/custom/InstaBlock/index.vue';

export default {
  name: 'SearchCatalog',
  mixins: [dynamicHead],
  components: {
    NewsCard,
    InstaBlock,
    ProductCard
  },
  data() {
    return {
      querySearch: '',
      searchData: null,
      instagramPosts: [],
      searchLoading: false,
      searchResultData: { news: [], products: [] }
    };
  },
  async created() {
    this.querySearch = this.$route.query.search;

    await Promise.all([
      this.getHomeInstagramPosts().then((result) => (this.instagramPosts = result)),
      this.fetchResults(),
      this.getPage(metaSlug).then((data) => {
        this.searchData = data;
        this._setMetaParams();
      })
    ]);
  },
  computed: {},
  methods: {
    ...mapActions({
      fetchSearchItems: 'search/GET_SEARCH_LIST',
      getHomeInstagramPosts: 'home/GET_HOME_INSTAGRAM_POSTS',
      getPage: 'staticPages/GET_PAGE'
    }),

    async fetchResults() {
      this.searchLoading = true;
      this.searchResultData = await this.fetchSearchItems(this.querySearch);
      this.searchLoading = false;
    },
    sendRequest: _.debounce(function () {
      if (this.querySearch.length > 2) {
        this.fetchResults();
      }
    }, 500),
    onChangeSearch() {
      this.sendRequest();
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.newsData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
